// @ts-nocheck
import React from "react";
import {ListaAreas} from "../ListaAreas";
import {ProvideAreas} from "../State/ProvideAreas";

export const Agenda = () => {

    return (
        <ProvideAreas>
            <ListaAreas></ListaAreas>
        </ProvideAreas>

    )
}